<template>
  <v-layout class="mdi-window__header">
    <span class="text--ellipsis pl-2">
      <span v-if="!infoMsg" class="mdi-window__header-text">{{ title }}</span>
      <span v-else class="mdi-window__notify-info-text">{{ infoMsg }}</span>
    </span>
    <v-spacer></v-spacer>
    <header-buttons @minimize="minimize"></header-buttons>
  </v-layout>
</template>

<script>
import HeaderButtons from '../ui/HeaderButtons.vue';

export default {
  props: {
    title: String,
  },
  components: {
    HeaderButtons,
  },
  data() {
    return {
      infoMsg: undefined,
    };
  },
  methods: {
    minimize($event) {
      this.$emit('onMinimize', $event);
    },
  },
};
</script>

<style></style>
